/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Errors_Failedtosigninwithgoogle5Inputs */

const he_auth_errors_failedtosigninwithgoogle5 = /** @type {(inputs: Auth_Errors_Failedtosigninwithgoogle5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתחברות עם Google נכשלה`)
};

const en_auth_errors_failedtosigninwithgoogle5 = /** @type {(inputs: Auth_Errors_Failedtosigninwithgoogle5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to sign in with Google`)
};

/**
* | output |
* | --- |
* | "Failed to sign in with Google" |
*
* @param {Auth_Errors_Failedtosigninwithgoogle5Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_errors_failedtosigninwithgoogle5 = /** @type {((inputs?: Auth_Errors_Failedtosigninwithgoogle5Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Errors_Failedtosigninwithgoogle5Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_errors_failedtosigninwithgoogle5(inputs)
	return en_auth_errors_failedtosigninwithgoogle5(inputs)
});
export { auth_errors_failedtosigninwithgoogle5 as "auth_errors_failedToSignInWithGoogle" }